export const COLLECTION_RELOAD_TIME = 300000
export const NOTIFICATION_DURATION = 6000

export const AVAILABILITY_FIELD_NAME = 'availability'
export const PRICE_AVAILABILITY_FIELD_NAME = 'price_availability'
export const REFERENCE_AVAILABILITY_FIELD_NAME = 'reference_availability'
export const TAX_APPLICABLE_FIELD_NAME = 'applicable_taxes'

export const ORDER_SYSTEM_STATUS_CANCELLED = 'cancelled'
export const ORDER_SYSTEM_STATUS_REJECTED = 'rejected'
export const ORDER_SYSTEM_STATUS_ACCEPTANCE = 'requires_acceptance'
export const ORDER_SYSTEM_STATUS_NORMAL = 'normal'
export const ORDER_SYSTEM_STATUS_MODIFIED = 'modified'

export const ORDER_STATUS_ON_HOLD = 'on-hold'
export const ORDER_STATUS_IN_PROGRESS = 'in-progress'
export const ORDER_STATUS_READY = 'ready'
export const ORDER_STATUS_ON_A_WAY_TO_FINISH = 'on-a-way'
export const ORDER_STATUS_FINISHED = 'finished'

export const ORDER_TYPE_WALK_IN = 'walk_in'
export const ORDER_TYPE_TAKEAWAY = 'online_takeaway'
export const ORDER_TYPE_DINEIN = 'dine_in'
export const ORDER_TYPE_CALL_CENTER = 'call_center'
export const ORDER_TYPE_ONLINE = 'online'
export const ORDER_TYPE_CARHOP = 'carhop'

export const ORDER_MODE_ONLINE = 'online'

export const DISCOUNT_TYPE_FIXED_PRICE = 'fixed_price'
export const DISCOUNT_TYPE_PERCENTAGE = 'percentage'
export const DISCOUNT_TYPE_VALUE = 'value'

export const PAYMENT_TYPE_LOYALTY_ID = 'loyalty'
export const PAYMENT_NAME_LOYALTY_POINTS = 'Loyalty Points'
export const PAYMENT_NAME_GO_ORDER_LOYALTY_POINTS = 'GoOrder Loyalty Points'
export const PAYMENT_TYPE_GIFT_CARD_ID = 'gift_card'
export const PAYMENT_TYPE_REGULAR_ID = 'regular'

export const PAY_BY_SAVED_CARD = 'saved_card_payment'
export const PAY_BY_CARD = 'card_payment'

export const BUSINESS_TYPE_HOMEMADE_FOOD = 'homemade_food'
export const BUSINESS_TYPE_RESTAURANT = 'restaurant'
export const BUSINESS_TYPE_GROCERY = 'grocery'
export const BUSINESS_TYPE_PHARMACY = 'pharmacy'
export const BUSINESS_TYPE_FLOWER = 'flower'
export const BUSINESS_TYPE_BARBER = 'barber'
export const BUSINESS_TYPE_BEAUTY_SALON = 'beauty_salon'
export const BUSINESS_TYPE_CLINIC = 'clinic'
export const BUSINESS_TYPE_AUTO_SERVICE = 'auto_service'
export const BUSINESS_TYPE_HOME_MAINTENANCE = 'home_maintenance'
export const WEBSITE_TYPE_TRANSLATIONS = ['w', 'mw']

export const REQUIRES_ACCEPTANCE = 'Awaiting acceptance'
export const IN_PROGRESS = 'Order preparing'
export const READY = 'Waiting for pick'
export const ON_A_WAY = 'Driver on the way'
export const FINISHED = 'Delivery - Finished'

//jeebly order status
export const CREATED = 'order preparing'
export const ASSIGNED = 'Driver assigned to order'
export const ACCEPT = 'Driver accepted delivery'

export const REACH_MERCHANT = 'Driver reached merchant'
export const DISPATCH = 'Order dispatched'
export const REACHED_CUSTOMER = 'Order reached to customer'
export const DELIVERED = 'Order delivered'
export const CANCELLED = 'Order cancelled'
export const RIDER_REJECTED = 'Driver rejected order'
export const RIDER_REMOVED = 'Driver Removed'
export const PAYMENT_REJECT = 'Order payment rejected'
export const DUTY_ACCEPT = 'Driver accepted to duty'
export const DUTY_START = 'Driver on the way to restaurant '
export const DUTY_COMPLETE = 'Order Delivered'
export const DUTY_CANCEL = 'Order cancelled'
export const ADDRESS_UPDATED = 'Address updated'
export const STOP_AUTO_ASSIGNMENT = 'Driver not assign automatic'
export const MANUAL_ASSIGMENT_CANCEL = 'Driver assignment cancel'

export const ORDER_HISTORY_TYPE_RECORD_NEW = 'Created'
export const ORDER_HISTORY_TYPE_RECORD_SENT_TO_KITCHEN =
  'Sent for Cooking/Assembly'
export const ORDER_HISTORY_TYPE_RECORD_READY = 'Ready'
export const ORDER_HISTORY_TYPE_RECORD_DELIVERY_STARTED = 'Delivery Started'
export const ORDER_HISTORY_TYPE_RECORD_DELIVERED = 'Delivered'

export const OTP_LENGTH = 6
export const OTP_VERIFICATION_FOR_MOBILE = 'mobile'
export const OTP_VERIFICATION_FOR_EMAIL = 'email'
export const OTP_VALID_UPTO_MOBILE = 300 // in Sec
export const OTP_VALID_UPTO_EMAIL = 300 // in Sec

export const ITEM_TYPE_COMBO = 'combo_item'
export const ITEM_TYPE_REGULAR = ['regular']

export const MODULE_FUTURE_ORDERS = 'Future Orders'
export const MODULE_WEBSITE = 'Website'

// Goorder Offer types
export const OFFER_TYPE_ITEM = 'food_item'
export const OFFER_TYPE_CATEGORY = 'food_category'
export const OFFER_TYPE_DISCOUNT = 'order_discount_item'
export const OFFER_TYPE_NO_SPECIFIC = 'no_specific_item'

export const CONTACT_US_SLUG = 'contact-us'
export const FAQ_SLUG = 'faq'
export const TERMS_AND_CONDITIONS_SLUG = 'terms-condition'
export const PRIVACY_POLICY_SLUG = 'privacy-policy'
export const ABOUT_US_SLUG = 'about'
export const HOW_IT_WORKS_SLUG = 'how-it-works'

export const ALL_CONSTANTS = {
  AVAILABILITY_FIELD_NAME: AVAILABILITY_FIELD_NAME,
  PRICE_AVAILABILITY_FIELD_NAME: PRICE_AVAILABILITY_FIELD_NAME,
  REFERENCE_AVAILABILITY_FIELD_NAME: REFERENCE_AVAILABILITY_FIELD_NAME,
  TAX_APPLICABLE_FIELD_NAME: TAX_APPLICABLE_FIELD_NAME,

  ORDER_STATUS_ON_HOLD: ORDER_STATUS_ON_HOLD,
  ORDER_STATUS_IN_PROGRESS: ORDER_STATUS_IN_PROGRESS,
  ORDER_STATUS_READY: ORDER_STATUS_READY,
  ORDER_STATUS_ON_A_WAY_TO_FINISH: ORDER_STATUS_ON_A_WAY_TO_FINISH,
  ORDER_STATUS_FINISHED: ORDER_STATUS_FINISHED,

  ORDER_TYPE_WALK_IN: ORDER_TYPE_WALK_IN,
  ORDER_TYPE_CARHOP: ORDER_TYPE_CARHOP,
  ORDER_TYPE_TAKEAWAY: ORDER_TYPE_TAKEAWAY,
  ORDER_TYPE_DINEIN: ORDER_TYPE_DINEIN,
  ORDER_TYPE_CALL_CENTER: ORDER_TYPE_CALL_CENTER,
  ORDER_TYPE_ONLINE: ORDER_TYPE_ONLINE,

  ORDER_SYSTEM_STATUS_CANCELLED: ORDER_SYSTEM_STATUS_CANCELLED,
  ORDER_SYSTEM_STATUS_NORMAL: ORDER_SYSTEM_STATUS_NORMAL,
  ORDER_SYSTEM_STATUS_MODIFIED: ORDER_SYSTEM_STATUS_MODIFIED,

  PAYMENT_TYPE_LOYALTY_ID: PAYMENT_TYPE_LOYALTY_ID,
  PAYMENT_TYPE_GIFT_CARD_ID: PAYMENT_TYPE_GIFT_CARD_ID,
  PAYMENT_TYPE_REGULAR_ID: PAYMENT_TYPE_REGULAR_ID,

  PAY_BY_CARD: PAY_BY_CARD,
  PAY_BY_SAVED_CARD: PAY_BY_SAVED_CARD,

  BUSINESS_TYPE_HOMEMADE_FOOD: BUSINESS_TYPE_HOMEMADE_FOOD,
  BUSINESS_TYPE_RESTAURANT: BUSINESS_TYPE_RESTAURANT,
  BUSINESS_TYPE_GROCERY: BUSINESS_TYPE_GROCERY,
  BUSINESS_TYPE_PHARMACY: BUSINESS_TYPE_PHARMACY,
  BUSINESS_TYPE_FLOWER: BUSINESS_TYPE_FLOWER,
  BUSINESS_TYPE_BARBER: BUSINESS_TYPE_BARBER,
  BUSINESS_TYPE_BEAUTY_SALON: BUSINESS_TYPE_BEAUTY_SALON,
  BUSINESS_TYPE_CLINIC: BUSINESS_TYPE_CLINIC,
  BUSINESS_TYPE_AUTO_SERVICE: BUSINESS_TYPE_AUTO_SERVICE,
  BUSINESS_TYPE_HOME_MAINTENANCE: BUSINESS_TYPE_HOME_MAINTENANCE,
  WEBSITE_TYPE_TRANSLATIONS: WEBSITE_TYPE_TRANSLATIONS,

  OFFER_TYPE_ITEM: OFFER_TYPE_ITEM,
  OFFER_TYPE_CATEGORY: OFFER_TYPE_CATEGORY,
  OFFER_TYPE_DISCOUNT: OFFER_TYPE_DISCOUNT,
  OFFER_TYPE_NO_SPECIFIC: OFFER_TYPE_NO_SPECIFIC,

  CONTACT_US_SLUG: CONTACT_US_SLUG,
  TERMS_AND_CONDITIONS_SLUG: TERMS_AND_CONDITIONS_SLUG,
  PRIVACY_POLICY_SLUG: PRIVACY_POLICY_SLUG,
  ABOUT_US_SLUG: ABOUT_US_SLUG,
  HOW_IT_WORKS_SLUG: HOW_IT_WORKS_SLUG,
  FAQ_SLUG: FAQ_SLUG,

  IN_PROGRESS: IN_PROGRESS,
  READY: READY,
  ON_A_WAY: ON_A_WAY,
  FINISHED: FINISHED,
  ORDER_SYSTEM_STATUS_REJECTED: ORDER_SYSTEM_STATUS_REJECTED,

  MODULE_FUTURE_ORDERS: MODULE_FUTURE_ORDERS,
  MODULE_WEBSITE: MODULE_WEBSITE,
}
